export const ADD_DESK_ERROR = 'ADD_DESK_ERROR';
export const ADD_DESK_LOADING = 'ADD_DESK_LOADING';
export const ADD_DESK_SUCCESS = 'ADD_DESK_SUCCESS';

export const UPDATE_DESK_ERROR = 'UPDATE_DESK_ERROR';
export const UPDATE_DESK_LOADING = 'UPDATE_DESK_LOADING';
export const UPDATE_DESK_SUCCESS = 'UPDATE_DESK_SUCCESS';

export const FETCH_DESK_ERROR = 'FETCH_DESK_ERROR';
export const FETCH_DESK_LOADING = 'FETCH_DESK_LOADING';
export const FETCH_DESK_SUCCESS = 'FETCH_DESK_SUCCESS';

export const FETCH_BY_ID_DESK_ERROR = 'FETCH_BY_ID_DESK_ERROR';
export const FETCH_BY_ID_DESK_LOADING = 'FETCH_BY_ID_DESK_LOADING';
export const FETCH_BY_ID_DESK_SUCCESS = 'FETCH_BY_ID_DESK_SUCCESS';

export const DELETE_DESK_ERROR = 'DELETE_DESK_ERROR';
export const DELETE_DESK_LOADING = 'DELETE_DESK_LOADING';
export const DELETE_DESK_SUCCESS = 'DELETE_DESK_SUCCESS';

export const DELETE_DESK_FAILURE = 'DELETE_DESK_FAILURE';
export const FETCH_DESK_FAILURE = 'FETCH_DESK_FAILURE';
export const UPDATE_DESK_FAILURE = 'UPDATE_DESK_FAILURE';

export const FETCH_ROOMS_ERROR = 'FETCH_ROOMS_ERROR';
export const FETCH_ROOMS_LOADING = 'FETCH_ROOMS_LOADING';
export const FETCH_ROOMS_SUCCESS = 'FETCH_ROOMS_SUCCESS';
